// extracted by mini-css-extract-plugin
export var activeLink = "footer-module--activeLink--1d230";
export var addressDiv = "footer-module--addressDiv--4d6e6";
export var addressLinkButton = "footer-module--addressLinkButton--b6f67";
export var emptyHeader = "footer-module--emptyHeader--733eb";
export var finalInfo = "footer-module--finalInfo--0e7e7";
export var footerAddressList = "footer-module--footerAddressList--fd31e";
export var footerLink = "footer-module--footerLink--b3e16";
export var footerList = "footer-module--footerList--9e187";
export var image = "footer-module--image--5b9d5";
export var imageDiv = "footer-module--imageDiv--4e6ea";
export var infoDiv = "footer-module--infoDiv--bede1";
export var innerStyleDiv = "footer-module--innerStyleDiv--39fc9";
export var socialLink = "footer-module--socialLink--ab523";